import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";

import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <div className="f-icons">
          <a href="https://www.instagram.com/__limitmax/">
            <Insta color="white" size={"3rem"} />
          </a>
          <a href="https://github.com/LimitMax">
            {" "}
            <Gitub color="white" size={"3rem"} />
          </a>

          <h3>Made With 💕 By Taufiq Q. R.</h3>
        </div>
      </div>
    </div>
  );
};

export default Footer;
